/* eslint-disable */
import Title from "../../Title";
import {
  CategoryList,
  CountersButtons,
} from "../../new-resolver/CountersButtons";
import BreadCrumb from "../../new-resolver/breadCrumb";
import { useFindDailyListing } from "../../new-resolver/useFindListings";
import css from "./.module.scss";
import styles from "@/components/login-alert/loginAlert.module.scss";
import ListingImages from "../ListingImages";
import { financialFormat } from "@/lib/helpers";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Modal, Skeleton, Tooltip } from "@aqar-app/react-ui";
import {
  useAuthState,
  useIsOwner,
  useIsOwnerByQuery,
} from "@/contexts/auth/auth.provider";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import logger from "../../../../console";
import { Icon } from "@/components/icon";

import { AlertForUser, CLOSED_STATUS_MAP } from "../ListingScreen/alert";
import { usePath } from "@/contexts/path/path";
import ListingVideo from "../ListingScreen/listingVideo";
import {
  CALC_DAILY_RENTING_PRICE,
  GET_RESERVED_DATES,
  GET_CUSTOM_BOOKING_DETAILS,
} from "@/graphql/queries/daily";
import dayjs from "dayjs";
import dynamic from "next/dynamic";
import { ClosedListing } from "../ListingScreen";
import {
  trackDailyRentPayment,
  trackDailyRentSetDate,
} from "@/lib/tracking/trackNavigationEvents";
import { PickerHolder } from "@/components/Listing/DailyListingScreen/pickerHolder";
import { ListingComments } from "@/components/Listing/comments";
import { OwnerControls } from "@/components/Listing/ListingScreen/ownerControls";
import {
  OwnerServices,
  PreciseLocationRequests,
} from "@/components/Listing/ListingScreen/ownerServices";
import {
  NextListingButton,
  PreviousListingButton,
} from "@/components/Listing/ListingScreen/generalControls";
import { RelatedListings } from "@/components/Listing/ListingScreen/relatedListings";

import { drawMarkerForSimpleListing } from "@/components/Listing/ListingScreen/DrawMarkerForSimpleListing";
import {
  trackDMRItemAddToCart,
  trackGuaranteeClick,
  trackViewDMRItem,
} from "@/lib/tracking/trackDMREvents";
import { NewSpecsComponent } from "@/components/Listing/table/newSpecsComponent";
import ReportButton from "@/components/Listing/ListingScreen/ListingControls/reportButton";
import { useDeviceViewPort } from "@/hooks/viewport";

import { cancellationPolicy } from "@/lib/cancellationPolicy";
import {
  listingToEECItemObject,
  trackAddToCart,
  trackViewItem,
} from "@/lib/tracking/trackEECEvents";
import { OwnerCalendarSkeleton } from "@/components/Listing/DailyListingScreen/ownerCalendar";
import { ShowMore } from "@/components/Listing/showMore";
import FavButton from "@/components/Listing/ListingScreen/ListingControls/favButton";
import ShareButton from "@/components/Listing/ListingScreen/ListingControls/shareButton";
import { TabsSpecs } from "@/components/Listing/table/tabsSpecs";
import { getJwt } from "@/lib/paymentHelpers";
import { GET_DAILY_RENT_GUARANTEE_CONFIG } from "@/graphql/queries/info";
import LikeButton from "@/components/Listing/ListingScreen/ListingControls/LikeButton";
import AdSpacesV2 from "@/components/Listing/ListingScreen/AdSpaceV2";
import { useListingStatusControl } from "@/hooks/useListingStatusControl";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";

const AdSpaces = dynamic(
  () => import("../ListingScreen/AdSpaces").then((m) => m.AdSpaces),
  {
    ssr: false,
  },
);
const OwnerCalendar = dynamic(
  () =>
    import("@/components/Listing/DailyListingScreen/ownerCalendar").then(
      (m) => m.OwnerCalendar,
    ),
  { ssr: false, loading: () => <OwnerCalendarSkeleton /> },
);
const LeafletMap = dynamic(
  () => import("../ListingScreen/LeafletMap").then((m) => m.LeafletMap),
  { ssr: false },
);
const SpacesModal = dynamic(
  () => import("../ListingScreen/spacesModal").then((m) => m.SpacesModal),
  {
    ssr: false,
  },
);

const DailyPicker = dynamic(
  () => import("./datepicker").then((m) => m.DailyPicker),
  {
    ssr: false,
    loading: PickerHolder,
  },
);

const OpenInAppBtn = dynamic(
  () => import("../ListingScreen/openInAppBtn").then((m) => m.OpenInAppBtn),
  {
    ssr: false,
  },
);
const TOW_DIGIT = new Intl.NumberFormat("en-sa", { minimumIntegerDigits: 2 });

function get12TimeFormat(hour) {
  const adjustedHour = hour % 12 || 12;
  const period = hour >= 12 ? "م" : "ص";
  return TOW_DIGIT.format(adjustedHour) + ":00 " + period;
}

export function DailyUi({ listing }) {
  const [minDate, setMinDate] = useState(
    dayjs(Date.now()).startOf("day").valueOf(),
  );
  const [calcPrice] = useLazyQuery(CALC_DAILY_RENTING_PRICE, {
    nextFetchPolicy: "network-only",
  });

  useEffect(() => {
    const id = setInterval(() => {
      if (new Date().getHours() >= 21) {
        setMinDate(dayjs(Date.now()).add(1, "day").startOf("day").valueOf());
        clearInterval(id);
      }
    }, 1000 * 60);

    return () => clearInterval(id);
  }, []);
  const {
    updateContext,
    category,
    dailyData,
    daily_renting_filter,
    categoriesDictionary,
    previousPath,
  } = usePath();

  const [price, setPrice] = useState(
    listing.range_price
      ? {
          total_price: listing.range_price,
          discounted_price: listing.range_price,
        }
      : undefined,
  );
  const [dates, setDates] = useState(
    daily_renting_filter
      ? {
          start: daily_renting_filter?.day_date?.gte,
          end: daily_renting_filter?.day_date?.lte,
        }
      : {},
  );
  const { user } = useAuthState();
  const [error, setError] = useState("");
  const router = useRouter();
  const [limit] = useState({
    start: Date.now(),
    end: Date.now() + 60 * 60 * 24 * 180 * 1000,
  });
  const datePickerRef = useRef();
  const { data } = useQuery(GET_RESERVED_DATES, {
    variables: {
      id: listing.id,
      ...limit,
    },
    ssr: false,
    fetchPolicy: "no-cache",
    skip: !listing?.id,
  });
  const booked = useMemo(
    () =>
      data?.DailyRenting?.getReservedDatesOfListing.map(
        (d) => d.reserved_date,
      ) || [],
    [data],
  );

  useEffect(() => {
    if (!dailyData?.price) return;
    setPrice(dailyData.price);
  }, [dailyData]);

  // Sync local dates with context so UI reflects updates (e.g. custom booking token parsing)
  useEffect(() => {
    if (daily_renting_filter && daily_renting_filter.day_date) {
      const start = daily_renting_filter.day_date.gte;
      const end = daily_renting_filter.day_date.lte;
      setDates({ start, end });
      if (datePickerRef.current?.reset) {
        try {
          datePickerRef.current.reset();
        } catch (e) {}
      }
    } else if (dailyData && (dailyData.start || dailyData.end)) {
      setDates({ start: dailyData.start, end: dailyData.end });
      if (datePickerRef.current?.reset) {
        try {
          datePickerRef.current.reset();
        } catch (e) {}
      }
    }
  }, [daily_renting_filter, dailyData]);

  return (
    <div dir="rtl" className={css.picker}>
      <div className={css.card}>
        <DailyPicker
          rows={6}
          decoratedButton={(data) => {
            if (data.oc)
              return (
                <Tooltip
                  showArrow
                  placement="top"
                  overlay={<div className={css.tooltip}>متاح للخروج فقط</div>}
                >
                  {data.btnUI}
                </Tooltip>
              );
            return data.btnUI;
          }}
          propRef={datePickerRef}
          booked={booked}
          onChange={({ start, end }) => {
            setDates({ start, end });
            if (!end)
              return updateContext({
                skipRouting: true,
                dailyData: {
                  ...dailyData,
                  price: undefined,
                },
              });

            trackDailyRentSetDate({
              property_category: category?.ga_property_category,
              start_date: dates?.start,
              end_date: dates?.end,
            });

            setError("");
            calcPrice({
              variables: {
                id: listing.id,
                start,
                end,
              },
            })
              .then(({ data: res, error }) => {
                if (error) return setError(error.message || "حدث خطأ");
                const fetchedPrice =
                  res?.DailyRenting?.getCalculatedBookingPriceWithDiscount ||
                  {};
                setPrice(fetchedPrice);
                updateContext({
                  skipRouting: true,
                  dailyData: {
                    ...dailyData,
                    start,
                    end,
                    price: fetchedPrice,
                  },
                });

                const eventData = {
                  listing_id: listing.id,
                  user_id: user?.user_id,
                  booking_start_date: start,
                  booking_end_date: end,
                  booking_total: fetchedPrice?.discounted_price,
                };
                logger.log(eventData);
              })
              .catch(logger.log);
          }}
          firstWeekDay={6}
          maxDate={dayjs().add(182, "days").valueOf()}
          minDate={minDate}
          selected={[]}
          range={dates}
        />

        {dates.start && dates.end ? (
          <div className={css.xpadding}>
            <div className={css.details}>
              <div>
                <p>تاريخ الحجز</p>
                <button
                  onClick={() => {
                    datePickerRef.current?.reset();
                    setDates({});
                    // clear context date selection
                    updateContext({
                      skipRouting: true,
                      dailyData: {
                        ...dailyData,
                        price: undefined,
                        start: undefined,
                        end: undefined,
                      },
                      daily_renting_filter: undefined,
                    });
                  }}
                  type="button"
                  className={css.date}
                >
                  <Icon width={10} height={10} name="Close" />

                  {dayjs(dates.start).format("DD MMM") +
                    " - " +
                    dayjs(dates.end).format("DD MMM")}
                </button>
              </div>

              {!error && price && (
                <div>
                  <p>السعر الإجمالي</p>
                  <p className={css.price}>
                    {!!(price.total_price - price.discounted_price) && (
                      <span className={css.discount}>
                        {financialFormat(price.total_price, "ريال")}
                      </span>
                    )}{" "}
                    {financialFormat(price.discounted_price, "ريال")}
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : null}
        {dates.start && dates.end && error && (
          <div className={css.error}>
            <p>{error}</p>
          </div>
        )}

        <div className={css.reserve}>
          <button
            onClick={() => {
              trackAddToCart(
                price.discounted_price,
                listingToEECItemObject(
                  listing,
                  undefined,
                  categoriesDictionary,
                ),
              );
              trackDMRItemAddToCart({
                source: previousPath || encodeURI(document.referrer),
                listing,
                categoriesDictionary,
                value: price.discounted_price,
              });
              getJwt({
                start_date: dates.start,
                end_date: dates.end,
                referral_code: router.query.referral_code,
                dscReason: price.discount_reason,
                value: price.discounted_price,
                value_in_halala: dailyData?.price?.discounted_price_int,
                original: price.total_price,
                listing_id: listing.id,
                custom_reservation_token:
                  router?.query?.["custom-booking-token"],
              }).then((res) => {
                router.push({
                  pathname: `/listings/${listing.id}/confirm`,
                  query: res,
                });
              });
            }}
            disabled={
              (!price?.discounted_price && !price?.total_price) ||
              error ||
              !dates.start ||
              !dates.end
            }
            type="button"
          >
            حجز الوحدة
          </button>
        </div>

        {!!0 && (
          <div className={css.reload}>
            <button
              onClick={() => datePickerRef.current.reset()}
              disabled={!dates.start || !dates.end}
            >
              <Icon width={15} height={15} name="reload-colored" />
              <span>مسح التواريخ</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
export function DailyUiMobile({ listing }) {
  const [minDate, setMinDate] = useState(
    dayjs(Date.now()).startOf("day").valueOf(),
  );
  const [calcPrice] = useLazyQuery(CALC_DAILY_RENTING_PRICE, {
    nextFetchPolicy: "network-only",
  });
  const { updateContext, daily_renting_filter, dailyData } = usePath();
  // const [price, setPrice] = useState(
  //   listing.range_price
  //     ? {
  //         total_price: listing.range_price,
  //         discounted_price: listing.range_price,
  //       }
  //     : undefined,
  // );
  const [dates, setDates] = useState(
    daily_renting_filter
      ? {
          start: daily_renting_filter?.day_date?.gte,
          end: daily_renting_filter?.day_date?.lte,
        }
      : {},
  );
  const { user } = useAuthState();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const datePickerRef = useRef();
  const [limit] = useState({
    start: Date.now(),
    end: Date.now() + 60 * 60 * 24 * 180 * 1000,
  });
  const { data } = useQuery(GET_RESERVED_DATES, {
    variables: {
      id: listing.id,
      ...limit,
    },
    ssr: false,
    fetchPolicy: "no-cache",
    skip: !listing?.id,
  });
  const booked = useMemo(
    () =>
      data?.DailyRenting?.getReservedDatesOfListing.map(
        (d) => d.reserved_date,
      ) || [],
    [data],
  );
  useEffect(() => {
    const id = setInterval(() => {
      if (new Date().getHours() >= 21) {
        setMinDate(dayjs(Date.now()).add(1, "day").startOf("day").valueOf());
        clearInterval(id);
      }
    }, 1000);

    return () => clearInterval(id);
  }, []);

  // Sync mobile picker dates with context updates (same reason as desktop UI)
  useEffect(() => {
    if (daily_renting_filter && daily_renting_filter.day_date) {
      setDates({
        start: daily_renting_filter.day_date.gte,
        end: daily_renting_filter.day_date.lte,
      });
      if (datePickerRef.current?.reset) {
        try {
          datePickerRef.current.reset();
        } catch (e) {}
      }
    } else if (dailyData && (dailyData.start || dailyData.end)) {
      setDates({ start: dailyData.start, end: dailyData.end });
      if (datePickerRef.current?.reset) {
        try {
          datePickerRef.current.reset();
        } catch (e) {}
      }
    }
  }, [daily_renting_filter, dailyData]);

  return (
    <div dir="rtl" className={css.picker}>
      <div className={css.card}>
        <div className={css.header}>
          <p>تاريخ بداية نهاية الحجز</p>
          <Modal.CloseButton />
        </div>
        <DailyPicker
          decoratedButton={(data) => {
            if (data.oc)
              return (
                <Tooltip
                  showArrow
                  placement="top"
                  overlay={<div className={css.tooltip}>متاح للخروج فقط</div>}
                >
                  {data.btnUI}
                </Tooltip>
              );
            return data.btnUI;
          }}
          propRef={datePickerRef}
          booked={booked}
          onChange={({ start, end }) => {
            if (!end) return;
            setDates({
              start,
              end,
            });
          }}
          firstWeekDay={6}
          maxDate={dayjs().add(182, "days").valueOf()}
          minDate={minDate}
          selected={[]}
          range={dates}
        />

        {dates.start && dates.end && error && (
          <div className={css.error}>
            <p>{error}</p>
          </div>
        )}

        <div className={css.reserveMobile}>
          <Button
            theme="info"
            onClick={(e) => {
              setLoading(true);
              setError("");
              calcPrice({
                variables: {
                  id: listing.id,
                  start: dates.start,
                  end: dates.end,
                },
              })
                .then(({ data: res, error }) => {
                  if (error) return setError(error.message || "حدث خطأ");

                  updateContext({
                    skipRouting: true,
                    dailyData: {
                      ...dates,
                      price:
                        res?.DailyRenting
                          ?.getCalculatedBookingPriceWithDiscount || {},
                    },
                    daily_renting_filter: {
                      availability: { eq: 1 },
                      day_date: {
                        gte: dates.start,
                        lte: dates.end,
                      },
                    },
                  });
                  const eventData = {
                    listing_id: listing.id,
                    user_id: user?.user_id,
                    booking_start_date: dates.start,
                    booking_end_date: dates.end,
                    booking_total:
                      res?.DailyRenting?.getCalculatedBookingPriceWithDiscount
                        ?.discounted_price,
                  };
                  logger.log(eventData);

                  Modal.close(e);
                })
                .catch((e) => {
                  logger.log(e);
                })
                .finally(() => setLoading(false));
            }}
            disabled={loading || !dates.start || !dates.end}
            type="button"
          >
            {loading ? (
              <Skeleton className={css.loading} />
            ) : dates.start && dates.end ? (
              "استمرار"
            ) : (
              "الرجاء تحديد تاريخ الوصول"
            )}
          </Button>
        </div>

        <div className={css.reload}>
          <button
            onClick={() => {
              datePickerRef.current.reset();
              setDates({});
            }}
            disabled={!dates.start || !dates.end}
          >
            <Icon width={15} height={15} name="reload-colored" />
            <span>مسح التواريخ</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export function DailyListingRules({ listing, extendedDetails, dailyData }) {
  if (
    extendedDetails?.insurance ||
    extendedDetails?.minimum_booking_days ||
    extendedDetails?.check_in_hour ||
    extendedDetails?.check_out_hour
  )
    return (
      <>
        <h4>قوانين الوحدة</h4>
        <div className={`${css.rules} ${css.card} ${css.bottomBorderOnly}`}>
          {!!extendedDetails?.check_in_hour && (
            <div>
              <p>وقت الوصول</p>
              <p>{get12TimeFormat(extendedDetails?.check_in_hour)}</p>
            </div>
          )}
          {!!extendedDetails?.check_out_hour && (
            <div>
              <p>وقت المغادرة</p>
              <p>{get12TimeFormat(extendedDetails?.check_out_hour)}</p>
            </div>
          )}
          {!!extendedDetails?.minimum_booking_days && (
            <div>
              <p>الحد الأدنى للحجز</p>
              <p>{extendedDetails?.minimum_booking_days} يوم</p>
            </div>
          )}
          <div>
            <p>إمكانية إلغاء الحجز</p>
            <p>
              {cancellationPolicy(
                listing?.daily_renting_grace_period,
                dailyData?.start,
              )}
            </p>
          </div>

          {!!extendedDetails?.insurance && (
            <div>
              <p>مبلغ التأمين</p>
              <p>{financialFormat(extendedDetails?.insurance) + " ريال"}</p>
            </div>
          )}
        </div>
      </>
    );

  return null;
}

const GuaranteePopup = () => {
  return (
    <Modal.ClassicOverlay dir="rtl">
      <div className={styles.popupContent}>
        <div className={styles.header}>
          <div className={styles.title}>عقار يحميك</div>
        </div>
        <div className={styles.body} style={{ padding: "18px 12px 12px 12px" }}>
          <div
            className={styles.text}
            style={{
              color: "#4D4D4D",
              marginBottom: "14px",
              textAlign: "center",
            }}
          >
            إذا واجهت أي اختلاف جوهري بين ما هو مذكور في الإعلان والواقع، فأنت
            محمي بخيارات تعويض مريحة:
          </div>
          <div className={styles.cardsRow}>
            <div className={styles.cardItem}>
              <span>
                <svg
                  width="18"
                  height="24"
                  viewBox="0 0 18 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0945 23.2886C16.542 21.6343 18 18.9 18 15.9686C18 11.7257 14.9711 7.05427 10.7011 6.04285L13.4783 2.82856C13.9209 2.3143 14.0251 1.61143 13.7387 0.994263C13.4436 0.385725 12.8447 0 12.1591 0H5.84087C5.15526 0 4.55642 0.385725 4.26131 0.994263C3.97494 1.61143 4.07909 2.3143 4.52172 2.82856L7.29892 6.04285C3.02892 7.05427 0 11.7257 0 15.9686C0 18.9 1.45805 21.6343 3.9055 23.2886C4.59111 23.7514 5.41562 24 6.30088 24H11.6991C12.5844 24 13.4089 23.7514 14.0945 23.2886ZM9.12152 19.6285H8.97394C7.72423 19.6285 6.50916 19.14 5.61521 18.2571C4.68662 17.3314 4.19192 16.1143 4.21793 14.8114C4.22661 14.4 4.29606 13.9628 4.42621 13.56C4.65187 12.8057 5.05981 12.1457 5.61521 11.5885C5.98845 11.2286 6.62199 11.2886 6.93442 11.6829L8.01928 13.1571C8.29701 13.5428 8.21025 14.0743 7.82837 14.3571C7.67211 14.4686 7.48988 14.52 7.31629 14.52C7.04725 14.52 6.78689 14.3914 6.61331 14.1685L6.2575 13.68C6.19674 13.8 6.12729 13.92 6.08391 14.0571C6.00577 14.3143 5.96239 14.5885 5.9537 14.8542C5.93633 15.6771 6.24881 16.4572 6.84765 17.0486C7.43781 17.6229 8.21888 17.94 9.06945 17.9143C9.5294 17.8714 9.94602 18.2743 9.96334 18.7457C9.98072 19.2171 9.60753 19.6114 9.12152 19.6285ZM11.0569 18.1543L9.98072 16.68C9.6943 16.3028 9.78112 15.7629 10.1716 15.4886C10.5622 15.2057 11.1003 15.2914 11.3867 15.6771L11.7425 16.1657C11.8033 16.0371 11.8727 15.9171 11.9161 15.78C11.9942 15.5057 12.0376 15.2486 12.0463 14.9914C12.055 14.1685 11.7425 13.3886 11.1523 12.7971C10.5622 12.2229 9.75506 11.8886 8.93055 11.9228C8.93055 11.9228 8.92187 11.9228 8.91323 11.9228C8.44454 11.9228 8.05398 11.5457 8.04534 11.0829C8.03666 10.6114 8.40984 10.2171 8.89586 10.2085C10.1456 10.1829 11.4475 10.68 12.3761 11.58C13.3047 12.5057 13.7994 13.7314 13.7821 15.0257C13.7734 15.4372 13.7039 15.84 13.5825 16.2686C13.3481 17.04 12.9402 17.7 12.3848 18.2571C12.0029 18.6257 11.378 18.5571 11.0569 18.1543Z"
                    fill="#66717E"
                  />
                </svg>
              </span>
              <p>استرداد كامل المبلغ</p>
            </div>
            <div className={styles.cardItem}>
              <span>
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.988791 2.43592L11.4235 0.0359322C11.6158 -0.00844068 11.8164 -0.0118546 12.0102 0.0264596C12.204 0.0640059 12.3859 0.142512 12.542 0.254468C12.6982 0.367107 12.8245 0.510124 12.9114 0.673963C12.9982 0.837801 13.0435 1.01769 13.0435 1.19996V22.7997C13.0439 22.9821 12.9991 23.1622 12.9123 23.3262C12.8255 23.49 12.6992 23.6339 12.5429 23.7462C12.3867 23.8588 12.2046 23.9365 12.0105 23.9742C11.8165 24.0118 11.6156 24.0084 11.4234 23.9637L0.988658 21.5637C0.706391 21.4988 0.455695 21.3492 0.276478 21.1382C0.0974636 20.9273 9.25064e-05 20.6674 -3.71933e-05 20.3996V3.59979C9.25064e-05 3.33218 0.097352 3.07211 0.276478 2.86133C0.455677 2.65039 0.706524 2.50077 0.988791 2.43592ZM6.5218 12.2254C6.5368 12.5345 6.68078 12.8261 6.9238 13.0398C7.16679 13.2536 7.49002 13.3729 7.82614 13.3729C8.16228 13.3729 8.48549 13.2535 8.72848 13.0398C8.97148 12.8261 9.11548 12.5343 9.13047 12.2254V11.773C9.13034 11.4547 8.99283 11.1495 8.74805 10.9247C8.50322 10.6998 8.17141 10.5735 7.82549 10.5737C7.47958 10.5738 7.14789 10.7 6.90332 10.9256C6.65888 11.1507 6.52167 11.456 6.5218 11.7741V12.2254Z"
                    fill="#66717E"
                  />
                  <path
                    d="M20 3.59992V20.3997C20 20.718 19.8625 21.0232 19.618 21.2483C19.3734 21.4734 19.0416 21.5997 18.6956 21.5997H14.7826V19.1997H17.3913V4.79986H14.7826V2.3999H18.6956C19.0416 2.3999 19.3733 2.52619 19.618 2.7513C19.8626 2.97644 20 3.28168 20 3.59992Z"
                    fill="#66717E"
                  />
                </svg>
              </span>
              <p>تعويض بحجز آخر</p>
            </div>
          </div>
          <div
            className={styles.text}
            style={{
              color: "#4D4D4D",
              marginTop: "16px",
              marginBottom: "24px",
              textAlign: "center",
            }}
          >
            احجز بثقة... دفعك آمن معنا
          </div>
          <div className={styles.actions}>
            <Button
              className={styles.okBtn}
              theme="primary"
              outline
              onClick={Modal.close}
            >
              حسنًا
            </Button>
          </div>
        </div>
      </div>
    </Modal.ClassicOverlay>
  );
};

export function DailyListingScreen({ frozenContext }) {
  const [listing] = useFindDailyListing();
  const { price, imgs, title, status, published } = listing;
  let isOpen = !CLOSED_STATUS_MAP[status];
  const isPaused = status === 5;
  const { user, token } = useAuthState();
  const [isMobile] = useDeviceViewPort();
  const {
    fields,
    extendedFields,
    updateContext,
    dailyData,
    daily_renting_filter,
    categoriesDictionary,
    category,
    city,
    district,
    previousPath,
  } = usePath();
  const router = useRouter();
  const extendedDetails = listing?.extended_details || {};

  const isOwnerPublic = useIsOwner(listing);
  const {
    isOwner: isOwnerAuth,
    loading: isOwnerLoading,
    ownerListing,
  } = useIsOwnerByQuery(listing?.id, !isPaused);
  const [calcPrice] = useLazyQuery(CALC_DAILY_RENTING_PRICE, {
    nextFetchPolicy: "network-only",
  });
  const [getCustomBooking] = useLazyQuery(GET_CUSTOM_BOOKING_DETAILS, {
    fetchPolicy: "no-cache",
  });

  const openResumeSuccessModal = () => {
    Modal.open(
      <ClassicModal
        newDesign
        close={false}
        cancel={false}
        title="عقار"
        ok={{
          label: "حسنًا",
          cb: (e) => {
            Modal.close(e);
            router.reload();
          },
        }}
        body={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <p style={{ maxWidth: "356px", textAlign: "center" }}>
              تم إعادة نشر الإعلان بنجاح
            </p>
          </div>
        }
      />,
    )();
  };

  const { handleResumeListing, resumeLoading } = useListingStatusControl({
    token,
    onSuccess: () => {
      openResumeSuccessModal();
    },
    id: listing.id,
  });

  useEffect(() => {
    if (!user || !listing) return;

    const space = listing.full?.new_listing_space_fees;

    if (!space?.popup || listing.full?.paid) return;
    Modal.open(<SpacesModal space={space} />)();
  }, [listing, user]);

  useEffect(() => {
    if (dailyData || !router.query.start || !router.query.end) return;

    calcPrice({
      variables: {
        id: listing.id,
        start: router.query.start,
        end: router.query.end,
      },
    }).then((res) => {
      const dates = {
        start: parseInt(router.query.start),
        end: parseInt(router.query.end),
      };
      updateContext({
        dailyData: {
          ...dates,
          price:
            res?.data?.DailyRenting?.getCalculatedBookingPriceWithDiscount ||
            {},
        },
        daily_renting_filter: {
          availability: { eq: 1 },
          day_date: {
            gte: dates.start,
            lte: dates.end,
          },
        },
      });
    });
  }, [dailyData, updateContext]);

  useEffect(() => {
    trackViewItem(
      listingToEECItemObject(listing, undefined, categoriesDictionary),
      {
        start_date: listing?.ga_start_date,
        end_date: listing?.ga_end_date,
        value: price,
      },
    );
    trackViewDMRItem({
      source: previousPath || encodeURI(document.referrer),
      listing: listing,
      categoriesDictionary,
    });
  }, []);

  const {
    data: {
      Info: {
        configurations: { show_daily_rent_guarantee_box },
      },
    } = { Info: { configurations: {} } },
  } = useQuery(GET_DAILY_RENT_GUARANTEE_CONFIG);

  useEffect(() => {
    try {
      const token = router?.query?.["custom-booking-token"];
      if (!token || dailyData) return;

      getCustomBooking({
        variables: {
          token: token,
        },
      })
        .then((res) => {
          const details = res?.data?.DailyRenting?.getCustomReservationDetails;
          if (!details) return;

          if (
            details.listing_id &&
            listing?.id &&
            details.listing_id !== listing.id
          ) {
            return;
          }

          const start = parseInt(details.start_date, 10);
          const end = parseInt(details.end_date, 10);

          const price = {
            total_price: details.total_price,
            discounted_price: details.total_price,
            discounted_price_int: details.total_price_int,
          };

          updateContext({
            skipRouting: true,
            dailyData: {
              start,
              end,
              price,
            },
            daily_renting_filter: {
              availability: { eq: 1 },
              day_date: {
                gte: start,
                lte: end,
              },
            },
          });
        })
        .catch((e) => {
          logger.log(e);
        });
    } catch (e) {
      logger.log(e);
    }
  }, [
    router?.query?.["custom-booking-token"],
    listing,
    dailyData,
    getCustomBooking,
    updateContext,
  ]);

  if (isPaused && isOwnerLoading) {
    return null;
  }

  if (isOwnerAuth && isPaused) {
    isOpen = true;
  }

  if (!isOpen) return <ClosedListing listing={listing} />;

  const isOwner = isOwnerPublic || isOwnerAuth;
  const fullListing = isOwner ? ownerListing || listing : listing;

  return (
    <div
      style={{
        background: "white",
      }}
    >
      <CategoryList />
      <div className={css.root}>
        <Title />
        <BreadCrumb />
        <div className={css.title}>
          <h1>{title}</h1>
        </div>
        <div className={css.images}>
          <div className={css.controls}>
            {isOwner && <OwnerControls listing={fullListing} />}
          </div>

          <div className={css.images}>
            <div className={css.controls}>
              {!isOwner && <LikeButton listing={listing} />}
              <FavButton listing={listing} />
              <ShareButton type="daily_rent_unit" listing={listing} />
              {isOwner ? <OwnerControls listing={fullListing} /> : null}
            </div>
            {isOpen && fullListing?.imgs && (
              <ListingImages
                listing={fullListing}
                loaded={listing.loadedImage}
              />
            )}
          </div>
        </div>

        <div className={css.priceWrapper}>
          <div className={css.price}>
            {dailyData?.price?.discounted_price ? (
              <>{financialFormat(dailyData?.price?.discounted_price, "ريال")}</>
            ) : (
              <button
                onClick={(e) => {
                  if (!isMobile) return;
                  Modal.open(<DailyUiMobile listing={listing} />)(e);
                }}
              >
                الرجاء إختيار فترة الحجز لعرض الأسعار
              </button>
            )}
          </div>
        </div>
        <div className={`${css.towColumns} ${isPaused && css.reversed}`}>
          <div>
            {!isOwner && show_daily_rent_guarantee_box ? (
              <div
                className={`${css.card} ${css.flexOne} ${css.guaranteeBox}`}
                onClick={() => {
                  trackGuaranteeClick({
                    source: previousPath || encodeURI(document.referrer),
                  });
                  Modal.open(<GuaranteePopup />)();
                }}
              >
                <svg
                  width="26"
                  height="30"
                  viewBox="0 0 26 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.3393 0.177934C13.4639 -0.0593113 12.5361 -0.0593113 11.6607 0.177934L3.53574 2.38001C1.44289 2.94722 0 4.76175 0 6.82644V15.1109C0 19.5913 2.281 23.7958 6.1244 26.3999L10.1665 29.1386C11.8615 30.2871 14.1385 30.2871 15.8335 29.1386L19.8755 26.3999C23.719 23.7958 26 19.5913 26 15.1109V6.82644C26 4.76175 24.5572 2.94722 22.4643 2.38001L14.3393 0.177934Z"
                    fill="#008236"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.5258 9.45077C19.1303 10.0803 19.1609 11.135 18.5942 11.8066L12.9693 18.4731C12.432 19.1101 11.5434 19.1783 10.9323 18.6296L7.55727 15.5993C6.91293 15.0208 6.81267 13.9715 7.33336 13.2555C7.85404 12.5395 8.79848 12.4282 9.44281 13.0067L11.7339 15.0638L16.4057 9.52677C16.9723 8.85526 17.9215 8.82122 18.5258 9.45077Z"
                    fill="white"
                  />
                </svg>

                <div className={css.guaranteeText}>
                  <div className={css.top}>عقار يحميك</div>
                  <div className={css.bottom}>
                    احجز من عقار ونضمن حقك لو واجهتك أي مشكلة
                  </div>
                </div>
                <span>
                  <svg
                    width="10"
                    height="16"
                    viewBox="0 0 10 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.265475 7.42932C-0.0884916 7.74024 -0.0884916 8.2597 0.265475 8.57141L8.43272 15.7638C8.79122 16.0787 9.37262 16.0787 9.73021 15.7638C10.0887 15.4489 10.0887 14.9374 9.73021 14.6225L2.21176 8L9.73112 1.37828C10.0896 1.06258 10.0896 0.551883 9.73112 0.236179C9.37262 -0.0787258 8.79122 -0.0787258 8.43362 0.236179L0.265475 7.42932Z"
                      fill="#008236"
                    />
                  </svg>
                </span>
              </div>
            ) : null}
            {listing.content ? (
              <div
                className={`${css.card} ${css.bottomBorderOnly} ${css.flexOne} ${css.flex}`}
              >
                {published && <ShowMore>{listing.content}</ShowMore>}
              </div>
            ) : null}

            <AlertForUser
              user={user}
              alert_box={fullListing.alert_box}
              listingUserId={fullListing.user_id}
            />
            <NewSpecsComponent
              fields={fields}
              extendedFields={extendedFields}
              listing={listing}
            />

            <DailyListingRules
              listing={listing}
              extendedDetails={extendedDetails}
            />

            {extendedDetails?.daily_renting_booking_conditions ? (
              <>
                <h4>شروط الحجز</h4>
                <div className={`${css.card} ${css.bottomBorderOnly}`}>
                  <p>{extendedDetails?.daily_renting_booking_conditions}</p>
                </div>
              </>
            ) : null}
            {!!listing?.has_video && (
              <ListingVideo videoItem={(listing?.videos || [])[0]} />
            )}
            <AdSpacesV2
              listingId={listing?.id}
              adTypes={[isMobile ? "space_3" : "wide_space_3"]}
            />
            {published && (
              <LeafletMap
                trackPdpMapEvent
                onMapReady={drawMarkerForSimpleListing(listing)}
              />
            )}

            {isMobile ? (
              <ReportButton className={css.report} listingID={listing.id} />
            ) : null}

            <OpenInAppBtn listingId={listing?.id} />

            <ListingComments listing={listing} />

            <TabsSpecs listing={listing} />
            {isMobile ? null : (
              <div className={css.changeControlls}>
                <PreviousListingButton
                  onListingChange={updateContext}
                  frozenContext={frozenContext}
                >
                  الإعلان السابق
                </PreviousListingButton>
                <NextListingButton
                  onListingChange={updateContext}
                  frozenContext={frozenContext}
                >
                  الإعلان التالي
                </NextListingButton>
              </div>
            )}
          </div>

          {isMobile ? (
            <div className={css.pickerWrapper}>
              {isOwner ? (
                <>
                  {isPaused && (
                    <Button
                      theme="info"
                      disabled={resumeLoading}
                      onClick={() => handleResumeListing({ id: listing.id })}
                    >
                      إعادة نشر الإعلان
                    </Button>
                  )}
                  <div className={css.calendar}>
                    <OwnerCalendar price={listing.price} id={listing.id} />
                  </div>
                  <div className={css.controls}>
                    <OwnerServices listing={fullListing} />
                  </div>
                </>
              ) : (
                <>
                  {isMobile ? null : (
                    <div className={css.desktopOnly}>
                      <DailyUi listing={listing} />
                      <ReportButton
                        className={css.report}
                        listingID={listing.id}
                      />
                    </div>
                  )}
                  <div className={css.mobilePicker}>
                    <PreviousListingButton
                      frozenContext={frozenContext}
                      onListingChange={(ev) => {
                        updateContext(ev);
                      }}
                    />
                    <div
                      onClick={Modal.open(<DailyUiMobile listing={listing} />)}
                      className={css.text}
                    >
                      {daily_renting_filter?.day_date ? (
                        <p>
                          {dayjs(daily_renting_filter.day_date.gte).format(
                            "DD MMM",
                          )}
                          -
                          {dayjs(daily_renting_filter.day_date.lte).format(
                            "DD MMM",
                          )}
                          &nbsp;
                          <button> تعديل</button>
                        </p>
                      ) : (
                        <button> الرجاء إختيار فترة الحجز لعرض الأسعار</button>
                      )}

                      <div>
                        {dailyData?.price?.total_price ? (
                          <p className={css.price}>
                            {!!(
                              dailyData?.price?.total_price -
                              dailyData?.price?.discounted_price
                            ) && (
                              <span className={css.discount}>
                                {financialFormat(
                                  dailyData?.price?.total_price,
                                  "ريال",
                                )}
                              </span>
                            )}{" "}
                            {financialFormat(
                              dailyData?.price?.discounted_price,
                              "ريال",
                            )}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        trackDailyRentPayment({
                          ...listing,
                          category,
                          city: city?.name,
                          district: district?.name,
                        });

                        trackDMRItemAddToCart({
                          source: previousPath || encodeURI(document.referrer),
                          listing,
                          categoriesDictionary,
                          value: price.discounted_price,
                        });

                        const start = daily_renting_filter?.day_date?.gte;
                        const end = daily_renting_filter?.day_date?.lte;

                        getJwt({
                          start_date: dailyData.start || start,
                          end_date: dailyData.end || end,
                          referral_code: router.query.referral_code,
                          dscReason: dailyData?.price.discount_reason,
                          value: dailyData?.price.discounted_price,
                          value_in_halala:
                            dailyData?.price?.discounted_price_int,
                          original: dailyData?.price.total_price,
                          listing_id: listing.id,
                          custom_reservation_token:
                            router?.query?.["custom-booking-token"],
                        }).then((res) => {
                          router.push({
                            pathname: `/listings/${listing.id}/confirm`,
                            query: res,
                          });
                        });
                      }}
                      theme="info"
                      className={css.reserve}
                      disabled={!dailyData?.price?.total_price}
                    >
                      حجز
                    </Button>
                    <NextListingButton
                      frozenContext={frozenContext}
                      onListingChange={(ev) => {
                        updateContext(ev);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className={css.pickerWrapper + " " + css.sticky}>
              {isOwner ? (
                <>
                  {isPaused && (
                    <Button
                      theme="info"
                      disabled={resumeLoading}
                      onClick={() => handleResumeListing({ id: listing.id })}
                    >
                      إعادة نشر الإعلان
                    </Button>
                  )}
                  <div className={css.calendar}>
                    <OwnerCalendar price={listing.price} id={listing.id} />
                  </div>
                  <div className={css.controls}>
                    <OwnerServices listing={fullListing} />
                  </div>
                </>
              ) : (
                <div>
                  <DailyUi listing={listing} />
                  <ReportButton className={css.report} listingID={listing.id} />
                </div>
              )}
            </div>
          )}
        </div>
        <CountersButtons bottom />

        <RelatedListings listing={listing} />
      </div>
    </div>
  );
}

export default DailyListingScreen;
